module.exports = __webpack_public_path__ + "img/step3.3f14376f.svg";